import { createContext, useContext, useReducer } from 'react';

const AppContext = createContext(null);

const AppDispatchContext = createContext(null);

const appReducer = (state, action) => {
    switch (action.type) {
        case "SELECT_STORE":
            window.localStorage.setItem('selectedStore', JSON.stringify(action.payload));
            return { ...state, selectedStore: action.payload };
        default:
            return state;
    }
}

const initialAppState = {
    selectedStore: window.localStorage.getItem('selectedStore') ? JSON.parse(window.localStorage.getItem('selectedStore')) : null,
}

export function AppProvider({ children }) {
    const [appState, appDispatch] = useReducer(
        appReducer,
        initialAppState
    );

    return (
        <AppContext.Provider value={appState}>
            <AppDispatchContext.Provider value={appDispatch}>
                {children}
            </AppDispatchContext.Provider>
        </AppContext.Provider>
    );
}

export function useApp() {
    return useContext(AppContext);
}

export function useAppDispatch() {
    return useContext(AppDispatchContext);
}